import React from "react";
import { CustomBreadcrumb } from "../../components";
import { SMART_PLANS_CONSTANTS } from "../../config/constants";
import { SmartPlansStyled } from "./styled";
import SmartPlansList from "./SmartPlansList";

const SmartPlans = () => {
  return (
    <CustomBreadcrumb
      header={SMART_PLANS_CONSTANTS.HEADER}
      currentPage={SMART_PLANS_CONSTANTS.BREADCRUMB_SMART_PLANS}
      isFromLandingPage={false}
    >
      <SmartPlansStyled>
        <SmartPlansList />
      </SmartPlansStyled>
    </CustomBreadcrumb>
  );
};

export default SmartPlans;
